import Vue from 'vue';
// import eventHelpers from './event-helpers';
import analyticsHelpers from './analytics-helpers';
// import priceHelpers from './price-helpers';
import validationHelpers from './validation-helpers';
// import listingPhotoHelpers from './listingPhotos-helpers';
// import headlineHelpers from './headline-helpers';
import indigoHelpers from './indigo-helpers';
import mobileDetect from './mobileDetect-helpers';

const helpers = {
  install: (Vue) => {
    Vue.prototype.$helpers = Object.assign({},
      // eventHelpers,
      analyticsHelpers,
      validationHelpers,
      // listingPhotoHelpers,
      // priceHelpers,
      // headlineHelpers,
      indigoHelpers,
      mobileDetect);
  },
};

Vue.use(helpers);
